'use strict';

import { generationAjaxCall } from '../genbar/generationBar';

// re-generate review
function reviewRegeneration () {
  const $data = $('.js-generation-data');
  const $genbar = $('#js-regenerate-form');
  const urlToReGenerate = $data.attr('data-regenerate-url');
  const domainToReGenerate = $data.attr('data-regenerate-domain');
  const competitorOne = $data.attr('data-regenerate-competitor-one');
  const competitorTwo = $data.attr('data-regenerate-competitor-two');
  const competitorThree = $data.attr('data-regenerate-competitor-three');

  const params =
    'url=' + urlToReGenerate +
    '&domain=' + domainToReGenerate +
    '&competitors[1]=' + competitorOne +
    '&competitors[2]=' + competitorTwo +
    '&competitors[3]=' + competitorThree;

  generationAjaxCall(params, $genbar);
}

$('.js-regenerate').on('click', function (event) {
  const $this = $(this);
  $this.addClass('busy');
  $this.parents('.dashboard-footer').find('a').addClass('disabled');
  reviewRegeneration();
});

module.exports = reviewRegeneration;
